export default function save() {
    // Dynamic block - rendering handled server side in PHP
    return null;
}
